import { z, ZodType } from 'zod';
import { zObject } from '../../util/zod';
import { WidgetsName, WidgetType } from './common';
import { widgetDatasourceTableContentSchema } from './widgetDatasourceTable';

export const widgetExcelDatasourceTableContentSchema = widgetDatasourceTableContentSchema.extend({
    uri: z.string().optional(),
});

export type WidgetExcelDatasourceTableContent = z.infer<typeof widgetExcelDatasourceTableContentSchema>;

export const widgetExcelDatasourceTableTypeSchema = zObject({
    name: z.literal(WidgetsName.ExcelDatasourceTable),
    uniqid: z.string(),
    content: widgetExcelDatasourceTableContentSchema,
}) satisfies ZodType<WidgetType<WidgetExcelDatasourceTableContent>>;

export type WidgetExcelDatasourceTableType = z.infer<typeof widgetExcelDatasourceTableTypeSchema>;
